import { useSignupPage, signupErrorReason } from 'utils/signupAnalytics';
import { localStorage as safeLocalStorage } from 'utils/browserStorage';
import React, {ChangeEvent, useEffect, useRef, useState} from 'react'
import { useHistory } from 'react-router';
import {
    MenuItem,
    FormControlLabel,
    Checkbox,
    FormControl
} from "@material-ui/core";

import {
    Page,
    Container,
    InputPhoneRoleBlock,
    BodyContainer,
    CountrySelectBlock,
    HeaderCountrySelect,
    BodyCountrySelect,
    ContinueButton,
    ChangeRoleBlock
} from "./SignUp1_Talent.styles";
import * as ls from "utils/localStorage";
import MaterialInput from "../../../components/Inputs/MaterialInput";
import {MaterialSelector} from "../../../components/Selector";
import Api from "../../../api";
import HeaderStatusBar from "../../../components/HeaderStatusBar";
import {formatDate, getTypeByRoleNumber, getRoleByTypeNumber} from "utils";
import MaskedInput from "react-input-mask";
import {Container as HeaderContainer, StarsContainer} from "components/SignUpHeader/SignUpHeader.styles";
import {roles, TALENT_MARKETING_SOURCES} from "utils/constants";
import FixedLoader from "../../../components/FixedLoader/FixedLoader";
import {useActionApi} from "../../../hooks";
import {HygienistProps} from "utils/types";
import TalentAddressUnitInput from "components/TalentAddressUnitInput";
import { composeTalentAddress, splitTalentAddress } from "utils/talentAddress";
import { normalizeSignupText } from '../../../utils/signupText';


// @ts-ignore
const TempStars: any = window.TempStars;
// @ts-ignore
const app = window.app;

interface rolesOptionsProps {
    name: string,
    value: number,
}

const rolesOptions: rolesOptionsProps[] = [{
    name: 'Dental Hygienist', value: roles.HYGIENIST
},{
    name: 'Dental Assistant', value: roles.ASSISTANT
},{
    name: 'Dental Admin / Manager', value: roles.FRONT_DESK
},{
    name: 'Associate Dentist', value: roles.ASSOCIATE_DENTIST
}]

interface ErrorProps {
    firstName?: string,
    lastName?: string,
    preferredName?: string,
    phone?: string,
    address?: string,
    roleSelect?: string,
    country?: string,
    state?: string,
    creation?: string,
    marketingSource?: string,
    otherSource?: string,
}

interface AutocompleteProps {
    buildingNumber?: string
    state: string,
    city?: string,
    postalCode?: string,
    address?: string,
    valueEqual?: boolean
}

interface completeRegistrationProps {
    firstName: string,
    lastName: string,
    preferredName?: string,
    phone: number,
    userType: string,
    userRole: string | undefined,
    role: number,
    autocomplete: AutocompleteProps,
    marketingSource: string,
}

const filterPhoneNumberToFormat = (phoneNumber: string | undefined): number => {
    const arr = phoneNumber?.match(/\d+/g)
    return Number(arr?.slice(1).join(''))
}

const marketingSmsLabel = 'I consent to receive marketing messages by SMS (Optional)';

interface SignUp1HeaderProps {
    title?: string,
    description?: string,
    error?: string
}

const SignUp1Header = ({title, description, error}: SignUp1HeaderProps) => {
    return <HeaderContainer>
        <div>
            <div className="screenDescription">
                {description}
            </div>
            <div className="screenTitle">
                {title}
            </div>
            {error && <div className="screenError">
                {error}
            </div>}
        </div>
        <div><StarsContainer/></div>
    </HeaderContainer>
}

export default function SignUp1_Talent() {
    const history = useHistory();
    const userAccount: {
        email: string;
        dentistId?: number,
        hygienistId?: number,
        dentist?: any,
        hygienist?: any
        id: number
    } = ls.get('userAccount') || {}

    const { hygienist } = userAccount;
    const signup = useSignupPage('talent_your_info', 'talent', hygienist?.type == null ? undefined : getRoleByTypeNumber(hygienist.type));

    const props = {
        hygienistId: hygienist?.id,
        country: hygienist?.country,
        role: getRoleByTypeNumber(hygienist?.type),
        province: hygienist?.province,
        duplicate: false,
    }
    const [loading, setLoading] = useState<boolean>(false);
    const [country, setCountry] = useState<0 | 1>(1); // 0 - CA
    const [screenError, setScreenError] = useState(false);
    const [autocompletedAddress, setAutocompletedAddress] = useState<AutocompleteProps | undefined>();
    const [addressUnit, setAddressUnit] = useState(splitTalentAddress(hygienist?.address).unit);
    const [errorMessage, setErrorMessage] = useState<ErrorProps | undefined>();
    const [marketingSource, setMarketingSource] = useState<string>('');
    const [otherSource, setOtherSource] = useState<string>('');
    const analyticsTracked = useRef(false);

    useEffect(() => {        
        TempStars.Autocomplete.init({country},({state, city, postalCode, address, buildingNumber, valueEqual}: AutocompleteProps) => {
            if (!address && !buildingNumber && !city) {
                setAutocompletedAddress(undefined);
            } else if (valueEqual) {
                const parsed = splitTalentAddress(address);
                setAddressUnit(current => current || parsed.unit);
                setAutocompletedAddress({state, city, postalCode, address: parsed.street, buildingNumber, valueEqual});
            }
        });
        
        return () => {
            TempStars.Autocomplete.removeListener();
        };
    }, [country])

    useEffect(() => {
        if (!analyticsTracked.current) {
            TempStars.Analytics.track('view_talent_createAccount', {
                country: country === 0 ? 'CA' : 'US',
                province: props.province || '',
                role: props.role
            });
            analyticsTracked.current = true;
        }
    },[]);

    useEffect(() => {
        if (!analyticsTracked.current) {
            TempStars.Analytics.track('view_talent_createAccount', {
                country: country === 0 ? 'CA' : 'US',
                province: props.province || '',
                role: props.role
            });
            analyticsTracked.current = true;
        }
    },[]);

    const [changeRoleLoading, ,changeRole] = useActionApi({
        apiMethod: Api.changeRole,
        onSuccess: () => { signup.switched('office'); history.push({pathname: 'SignUp1_DO'}); },
        onError: (error) => signup.error(signupErrorReason(error)),
    });


    const [createHygienistLoading, , createHygienist] = useActionApi({
        apiMethod: async (data: any) => {
            const result = await Api.createHygienist(data);
            signup.submitted({ role: getRoleByTypeNumber(data.type) });
            return result;
        },
        onSuccess: async () => {
            const auth = await Api.reLogin();
            let userAuth = {
                jwtToken: auth.token
            };
            ls.set('userAuth', userAuth);
            TempStars.Api.setAuthJwtToken(auth.token);
            await Api.updateToken()
            app.hidePreloader();
            props.duplicate = false;
            const updatedUserAccount = await Api.getUser(); // Fetch the latest user data
            ls.set('userAccount', updatedUserAccount);

            history.push({ 
                pathname: 'SignUp2_Talent', 
                state: { 
                    updatedHygienist: updatedUserAccount.hygienist,
                    duplicate: props.duplicate, 
            }
            });
        },
        onError: async (err) => {
            signup.error(signupErrorReason(err));
            if (signupErrorReason(err) === 'duplicate_account') {
                props.duplicate = true;
                signup.duplicate();
                TempStars.Analytics.track('Select-Route', {
                    route_selected: 'route_duplicate'
                });
                const updatedUserAccount = await Api.getUser(); // Fetch the latest user data
                ls.set('userAccount', updatedUserAccount);
                history.push({ 
                pathname: 'SignUp2_Talent', 
                state: { 
                    updatedHygienist: updatedUserAccount.hygienist,
                    duplicate: props.duplicate, 
            }
            });
            }
        }
    });

    const changeRoleToDentist = () => {
        TempStars.Analytics.track('Select-Route', {
            route_selected: 'UserToDentalOffice'
        });
        changeRole(roles.DENTIST);
    }

    const handleSignOut = () => {
        // Clear React state and local storage
        ls.remove('userAuth');
        ls.remove('userAccount');
        safeLocalStorage.removeItem('userAuth');
        safeLocalStorage.removeItem('userAccount');
        
        // After signing out, send returning users to Login rather than the
        // role-picker. They can still start a new signup from Login's
        // "Sign Up" link if needed.
        history.push({
            pathname: 'Login'
        });
    }

    const completeRegistration = async ({firstName, lastName, preferredName, phone, userRole, role, autocomplete, marketingSource}: completeRegistrationProps) => {
        let canonicalAddress: string;
        try { canonicalAddress = composeTalentAddress(autocomplete.address, addressUnit); }
        catch (error) {
            setErrorMessage({address: (error as Error).message});
            setLoading(false);
            return;
        }
        TempStars.Analytics.track('sign-up - complete user info form', {
            userRole,
            country,
            state: autocomplete.state
        } );

        try {
            await Api.createUserRole({roleId: Number(role), userId: Number(userAccount.id)})
            const type = getTypeByRoleNumber(Number(role));
            const trimmedPreferred = (preferredName || '').trim();
            const formData = {
                createdOn: formatDate(new Date(), 'YYYY-MM-DD'),

                firstName: normalizeSignupText(firstName),
                lastName: normalizeSignupText(lastName),
                preferredName: trimmedPreferred ? trimmedPreferred.slice(0, 50) : null,
                phone: phone,
                country: country,

                province: autocomplete.state,
                city: autocomplete.city,
                postalCode: autocomplete.postalCode,
                address: canonicalAddress,
                isComplete: 0,
                type,
                marketingSource: normalizeSignupText(otherSource) || normalizeSignupText(marketingSource),
            };
            await createHygienist(formData);
        } catch (e : any) {
            signup.error(signupErrorReason(e));
            if (signupErrorReason(e) === 'duplicate_account') {
                props.duplicate = true;
                signup.duplicate();
                TempStars.Analytics.track('Select-Route', {
                    route_selected: 'route_duplicate'
                });
                const updatedUserAccount = await Api.getUser(); 
                ls.set('userAccount', updatedUserAccount);

                history.push({ 
                pathname: 'SignUp2_Talent', 
                state: { 
                    updatedHygienist: updatedUserAccount.hygienist,
                    duplicate: props.duplicate, 
                }
            });
            } else {
                setErrorMessage({creation: 'Unable to save your information. Please try again.'});
            return setScreenError(true);
            }
        }
    }

    const changeCountry = (event: ChangeEvent<HTMLInputElement>) => {
        event.preventDefault()
        if (event.target.name === 'us') {
            setCountry(1)
        } else {
            setCountry(0)
        }
    }

    const onSubmit = async (event: any) => {
        event.preventDefault()
        // it is a quick fix. needed to change to react-hook-form
        setLoading(true);

        const {firstName, lastName, preferredName, phone, address, roleSelect, ca, us} = event.target
        if (roleSelect.value) signup.setRole(Number(roleSelect.value));
        
        let errors = {}

        if (!normalizeSignupText(firstName.value)) {
            errors = {...errors, firstName: 'Please enter Legal first name'};
        }
        if (!normalizeSignupText(lastName.value)) {
            errors = {...errors, lastName: 'Please enter Legal last name'};
        }
        if (!phone.value.length || phone.value.length < 16) {
            errors = {...errors, phone: 'Please enter Mobile'};
        }
        
        if (!address.value.length && !autocompletedAddress) {
            errors = {...errors, address: 'Please enter your address'};
        } 
        else if (address.value.length && !autocompletedAddress) {
            errors = {...errors, address: 'Please select your address from the list'};
        }
        else if (autocompletedAddress && !autocompletedAddress.buildingNumber?.length) {
            errors = {...errors, address: 'Add your building #, street'};
        }
        
        if (autocompletedAddress && (autocompletedAddress.state === 'CA' || autocompletedAddress.state === 'California')) {
            errors = {...errors, address: 'We are not currently operating in California. Please select a different address.'};
        }
        
        if (!roleSelect.value.length) {
            errors = {...errors, roleSelect: 'Please choose your role'};
        }
        if (country !== 0 && country !== 1) {
            errors = {...errors, country: 'Please choose your country'};
        }
        if (!marketingSource) {
            errors = {...errors, marketingSource: 'Please select how you heard about us'};
        }
        if (marketingSource.length > 150) {
            errors = {...errors, marketingSource: 'Response too long. Maximum 150 characters.'};
        }
        if (marketingSource === 'other' && !otherSource.trim()) {
            errors = {...errors, otherSource: 'Please specify how you heard about us'};
        }
        if (marketingSource === 'other' && otherSource.length > 150) {
            errors = {...errors, otherSource: 'Response too long. Maximum 150 characters.'};
        }

        const type = getTypeByRoleNumber(Number(roleSelect.value));
        const phoneNumber = filterPhoneNumberToFormat(phone.value);

        if (phoneNumber) {
            if (phoneNumber.toString().length < 10) {
                errors = {...errors, phone: 'Phone number is too short.'};
            } else {
                try {
                    await Api.checkUniqueHygienistPhoneNumber({phone: phoneNumber, type})
                } catch (e: any) {
                    errors = {...errors, phone: 'Oops! This phone number seems to already be in use.'};
                }
            }
        }

        if(Object.values(errors).find((err: any) => !!err.length)) {
            setErrorMessage(errors as ErrorProps);
            setLoading(false);
            signup.error('validation_failed');
            return setScreenError(true);
        } else {
            setErrorMessage(undefined);
            setScreenError(false);
        }

        let userType: string = '';
        let userRole: string | undefined = undefined;

        switch (roleSelect.value) {
            case roles.HYGIENIST:
                userType = 'Dental Worker';
                userRole = 'Hygienist';
                break;
            case roles.ASSISTANT:
                userType = 'Dental Worker';
                userRole = 'Assistant';
                break;
            case roles.FRONT_DESK:
                userType = 'Front Desc';
                userRole = 'Front Desc';
                break;
            case roles.ASSOCIATE_DENTIST:
                userType = 'Associate Dentist';
                userRole = 'Associate Dentist';
                break;
        }

        setLoading(false);
        
        if (!autocompletedAddress && address.value.length) {
            const defaultAddress = {
                state: country === 0 ? 'ON' : 'FL',
                postalCode: '',
                address: address.value,
                buildingNumber: '1', 
                valueEqual: true
            };
            
            return completeRegistration({
                firstName: firstName.value,
                lastName: lastName.value,
                preferredName: preferredName?.value,
                phone: phoneNumber,
                userType,
                userRole,
                role: roleSelect.value,
                autocomplete: defaultAddress,
                marketingSource,
            });
        }
        
        return autocompletedAddress && completeRegistration({
            firstName: firstName.value,
            lastName: lastName.value,
            preferredName: preferredName?.value,
            phone: phoneNumber,
            userType,
            userRole,
            role: roleSelect.value,
            autocomplete: autocompletedAddress,
            marketingSource,
        });
    };

    return (
        <Page>
            <Container>
                <HeaderStatusBar buttonClassName={'logout-link'} buttonText={'Sign Out'} withArrow onButton={handleSignOut} />

                <BodyContainer>
                    <SignUp1Header
                        title="Let's get to know you..."
                        description="Great to have you onboard!"
                        error={screenError
                            ? 'Please fix the errors below'
                            : errorMessage?.creation
                                ? errorMessage.creation
                                : undefined
                    }
                    />

                    <form id="signup-form" data-testid="signup-talent-contact-form" className="content-block contentBlock" onSubmit={onSubmit}>
                        <div className="list-block inset inputBox inputBlock">
                            <MaterialInput
                                label="Legal first name"
                                type={"text"}
                                id={'fName'}
                                name={"firstName"}
                                error={!!errorMessage?.firstName}
                                helperText={!!errorMessage?.firstName && errorMessage.firstName}
                            />
                            <MaterialInput
                                label="Legal last name"
                                id={'lName'}
                                name={"lastName"}
                                type={"text"}
                                error={!!errorMessage?.lastName}
                                helperText={!!errorMessage?.lastName && errorMessage.lastName}
                            />
                            <MaterialInput
                                label="Preferred name"
                                id={'preferredName'}
                                name={"preferredName"}
                                type={"text"}
                                inputProps={{ inputProps: { maxLength: 50 } } as any}
                                helperText={errorMessage?.preferredName || "What you go by day-to-day (optional)."}
                                error={!!errorMessage?.preferredName}
                            />
                        </div>
                        <InputPhoneRoleBlock className="list-block inset">
                            {/* @ts-ignore */}
                            <MaskedInput
                                mask="+1(999) 999-9999"
                            >
                                {/* @ts-ignore */}
                                {(inputProps: any) => (
                                    <MaterialInput
                                        {...inputProps}
                                        label="Phone Number"
                                        id={'phone'}
                                        name={"phone"}
                                        type={'text'}
                                        error={!!errorMessage?.phone}
                                        helperText={!!errorMessage?.phone && errorMessage.phone}
                                    />
                                )}
                            </MaskedInput>
                            <MaterialSelector id={'roleSelect'} name={'roleSelect'} label={'What is your role?'} errorMessage={errorMessage?.roleSelect}>
                                {rolesOptions.map((role) => <MenuItem value={role.value}>{role.name}</MenuItem>)}
                            </MaterialSelector>
                        </InputPhoneRoleBlock>

                        <CountrySelectBlock className="list-block inset">
                            <HeaderCountrySelect>Where are you based?</HeaderCountrySelect>
                            <BodyCountrySelect>
                                <FormControlLabel
                                    className={'no-fastclick'}
                                    control={<Checkbox
                                        icon={<img id="officeCheckmark" className="hidden-icon" alt=""
                                                   src={"img/dotCheck_inactive.svg"}/>}
                                        checkedIcon={<img id="officeCheckmark" className="hidden-icon" alt=""
                                                          src={"img/dotCheck_active.svg"}/>}
                                        name="ca"
                                        checked={country === 0}
                                        onChange={changeCountry}
                                    />}
                                    label="Canada"
                                />
                                <FormControlLabel
                                    className={'no-fastclick'}
                                    control={<Checkbox
                                        icon={<img id="officeCheckmark" className="hidden-icon" alt=""
                                                   src={"img/dotCheck_inactive.svg"}/>}
                                        checkedIcon={<img id="officeCheckmark" className="hidden-icon" alt=""
                                                          src={"img/dotCheck_active.svg"}/>}
                                        name="us"
                                        checked={country === 1}
                                        onChange={changeCountry}
                                    />}
                                    label="USA"
                                />
                            </BodyCountrySelect>
                            <div className={'inputTextField'}>
                                <div id="agreed-error-msg" className={'errorMsg'}>
                                    {errorMessage?.country}
                                </div>
                            </div>
                        </CountrySelectBlock>

                        <div className="list-block inset inputBox">
                            <MaterialInput
                                className={'no-fastclick'}
                                label="Start typing your address ..."
                                id={'autocomplete'}
                                name={"address"}
                                type={"text"}
                                error={!!errorMessage?.address}
                                helperText={!!errorMessage?.address && errorMessage.address}
                            />
                            <TalentAddressUnitInput scope="talent-signup" value={addressUnit} onChange={setAddressUnit} />
                            <div style={{fontSize: '0.75rem', color: '#666', textAlign: 'right', marginTop: '4px'}}>
                                Looking for California? We're not there just yet!
                            </div>
                        </div>
                        <div className="list-block inset">
                            <FormControl fullWidth>
                                <MaterialInput
                                    select
                                    className={'no-fastclick'}
                                    label="How did you hear about us?"
                                    value={marketingSource}
                                    onChange={(e) => {
                                        setMarketingSource(e.target.value);
                                    }}
                                    error={!!errorMessage?.marketingSource}
                                    helperText={errorMessage?.marketingSource}
                                    name="marketingSource"
                                    id="marketing-source"
                                >
                                    {TALENT_MARKETING_SOURCES.map((source) => (
                                        <MenuItem key={source.value} value={source.value}>
                                            {source.label}
                                        </MenuItem>
                                    ))}
                                </MaterialInput>
                            </FormControl>
                        </div>
                        {marketingSource === 'other' && (
                            <div className="list-block inset">
                                <MaterialInput
                                    label="Please specify"
                                    value={otherSource}
                                    onChange={(e) => setOtherSource(e.target.value)}
                                    error={!!errorMessage?.otherSource}
                                    helperText={errorMessage?.otherSource}
                                    name="otherSource"
                                />
                            </div>
                        )}
                        <ContinueButton
                            disabled={loading}
                            variant="contained"
                            color="primary"
                            size="large"
                            id="signup-button"
                            type={'submit'}
                        >
                            Continue
                        </ContinueButton>
                        <ChangeRoleBlock>Are you a dental office? <a onClick={changeRoleToDentist}>Click here to register your office</a></ChangeRoleBlock>
                    </form>
                </BodyContainer>
                <div className="footer">
                </div>
            </Container>
            <FixedLoader loading={loading || changeRoleLoading || createHygienistLoading}/>
        </Page>
    )
}
